<template>
  <div>
    <sub-menu
      :title="title"
      :routes="routes"
    ></sub-menu>

    <router-view></router-view>
  </div>
</template>

<script>
import SubMenu from '@/components/SubMenu.vue'
import { mapGetters } from 'vuex'


export default {
  data() {
    return {
      title: 'trading',
      routes:[
        { path: '/trading-account', title: 'account_list' },
        { path: '/trading-account/vps', title:'vps' },
        { path: '/trading-account/download', title: 'platforms' },
      ]
    }
  },
  components: {
    SubMenu,
  },
  computed: {
    ...mapGetters({
      Language: 'language/code',
    }),
  },
}
</script>
